import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { hasFullAccess } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
import { Box, Button, Container, Typography, useTheme, TextField, InputAdornment, } from "@mui/material";
import { Plus, MagnifyingGlass } from "@phosphor-icons/react/dist/ssr";
const ObjectStatusTopHeader = ({ openPopup, translate, searchQuery, onSearchChange, }) => {
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const isFullAccess = hasFullAccess(RolesPermissions, Modules.ChangeObjectStatus);
    const theme = useTheme();
    return (_jsx(Container, { disableGutters: true, sx: { maxWidth: "100% !important" }, children: _jsxs(Box, { sx: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                my: 3
            }, children: [_jsx(Box, { children: _jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary }, children: translate("ObjectStatus") }) }), _jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: "row",
                        gap: 1
                    }, children: [_jsx(TextField, { fullWidth: true, placeholder: translate("SearchByName") || "Search by name...", value: searchQuery, onChange: (e) => onSearchChange(e.target.value), sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "8px",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                },
                            }, slotProps: {
                                input: {
                                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(MagnifyingGlass, { size: 20, color: theme.palette.text.secondary }) })),
                                }
                            } }), isFullAccess && (_jsx(Button, { variant: "contained", fullWidth: true, 
                            // size="medium"
                            sx: { whiteSpace: "nowrap" }, startIcon: _jsx(Plus, {}), onClick: openPopup, children: translate("NewObjectStatus") }))] })] }) }));
};
export default ObjectStatusTopHeader;
